import axios from "axios";
import { download } from "fe-shared/src/helpers/files";

export const downloadFile = (path: string, fileName: string) =>
  axios
    .get(path, {
      responseType: "blob",
    })
    .then((res) => download(fileName, res));

export default downloadFile;
